import { View } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(View, theme => {
  return {
    base: {
      backgroundColor: 'transparent',
      minWidth: 240,
      maxWidth: 319,
      height: 'auto',
    },
    variants: {
      variant: {
        small: {
          minWidth: 240,
          maxWidth: 319,
        },
        medium: {
          minWidth: 320,
          maxWidth: 719,
        },
      },
    },
  }
})

export const ClosableButtonContainer = styled(View, theme => {
  return {
    base: {
      marginLeft: 'auto',
      width: 80,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'transparent',
    },
    variants: {},
  }
})

export const ModalDescriptionContainer = styled(View, theme => {
  return {
    base: {
      borderColor: theme.colorContainerBorderDefault,
      backgroundColor: theme.colorContainerFillDefault,
      borderRadius: theme.borderRadiusNone,
      paddingTop: theme.paddingInsetTwopulse,
      paddingBottom: theme.paddingInsetTwopulse,
      paddingLeft: theme.paddingInsetSixpulse,
      paddingRight: theme.paddingInsetSixpulse,
      borderLeftWidth: theme.borderWidthQuarterpulse,
      borderRightWidth: theme.borderWidthQuarterpulse,
    },
    variants: {
      variant: {
        small: {
          minWidth: 240,
          maxWidth: 319,
        },
        medium: {
          minWidth: 320,
          maxWidth: 719,
        },
      },
    },
  }
})
